import { useLocation, Link } from 'react-router-dom';
import { CheckCircle, Package } from 'lucide-react';
import { OrderLoyaltySummary } from '@/components/LoyaltyUI';
import { Button } from '@/components/ui/button';
import { getCurrencySymbol, convertPrice } from '@/lib/cartStore';

export default function OrderConfirmed() {
  const { state } = useLocation();
  const order = state?.order;
  return (
    <div className="max-w-md mx-auto px-4 py-16 text-center">
      <div className="w-16 h-16 mx-auto rounded-full bg-green-100 flex items-center justify-center mb-4"><CheckCircle className="h-8 w-8 text-green-600" /></div>
      <h1 className="font-heading font-bold text-2xl text-foreground mb-2" data-testid="order-confirmed-title">¡Pedido Realizado!</h1>
      {order && <p className="text-sm text-foreground mb-1">Número de pedido: <span className="font-bold">{order.order_number}</span></p>}
      <p className="text-muted-foreground text-sm mb-2" data-testid="order-payment-notice">Pedido registrado con stock reservado. Pago externo pendiente: esta aplicación no ha realizado ningún cobro.</p>
      {order && <p className="text-sm mb-6">Total: <span className="font-bold">{getCurrencySymbol(order.currency)}{convertPrice(order.total, order.currency)}</span></p>}
      <OrderLoyaltySummary order={order} id="confirmed-order-loyalty"/>
      <div className="flex flex-col gap-2">
        <Link to="/mis-pedidos"><Button className="w-full bg-secondary text-secondary-foreground hover:bg-secondary/90 rounded-full gap-2"><Package className="h-4 w-4" /> Ver Mis Pedidos</Button></Link>
        <Link to="/"><Button variant="ghost" className="w-full text-muted-foreground">Volver al Inicio</Button></Link>
      </div>
    </div>
  );
}
